<template>
  <div>
    <list-form
      ref="list-form"
      :formModel="formModel"
      :config="config"
    >
      <template v-slot="{ data, item, updateDataItem, autoSave }">
        <activity-item
          :data="data"
          :item="item"
          :formModel="formModel"
          :autoSave="autoSave"
          @change="updateDataItem"
          @onSendEmail="handlerSendEmail"
          @updatedData="refresh"
          @onStockCard="handlerStockCard"
        >
        </activity-item>
      </template>
    </list-form>
    <dialog-stock-card
      ref="dialog-stock-card"
    />
    <dialog-new-instruction-customer />
    <dialog-status-customer />
  </div>
</template>

<script>
import { waitValue } from '@/utils/promises'
import { MainModel } from '@/models/CustomerPOFollowUp'
import listFormConfig from './ListFormConfig'
import { equals, makeFilter } from '@/utils/dynamic'

export default {
  name: 'TabCustomerPoFollowUp',
  components: {
    'list-form': () => import(/* webpackChunkName: 'ListForm' */ '@/components/ListForm/Index'),
    'activity-item': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/ActivityItemCustomerPoFollowUp/Index'),
    'dialog-stock-card': () => import(/* webpackChunkName: 'DialogStockCard' */ '@/components/Shared/Activity/DialogStockCard'),
    'dialog-new-instruction-customer': () => import(/* webpackChunkName: 'DialogNewInstructionCustomer' */ '@/components/Shared/ActivityDialogNewInstructionCustomer'),
    'dialog-status-customer': () => import(/* webpackChunkName: 'ActivityDialogStatusEmailCustomer' */ '@/components/Shared/ActivityDialogStatusEmailCustomer')
  },
  props: {
    rfqid: { type: String }
  },
  data () {
    return {
      data: {},
      config: listFormConfig
    }
  },
  watch: {
    rfqid (val) {
      if (val) {
        this.loadData()
      }
    }
  },
  methods: {
    formModel () {
      return new MainModel()
    },
    refresh () {
      this.getListForm()
        .then((listForm) => {
          listForm.refresh()
        })
    },
    getListForm () {
      return waitValue(() => this.$refs['list-form'])
    },
    loadData () {
      if (!this.rfqid) return
      this.getListForm()
        .then((listForm) => {
          listForm.setFilters(makeFilter('rfqid', this.rfqid, equals))
          listForm.loadData()
        })
    },
    handlerStockCard () {
      this.$refs['dialog-stock-card'].show(...arguments)
    },
    handlerSendEmail () {
      this.$emit('onSendEmail', ...arguments)
    }
  }
}
</script>
